import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { Wrapper, WrapperCheckbox, Field, CheckboxStyled } from './styles.js';
import { CheckboxIcon } from './utils/CheckboxIcon.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Checkbox = (_a) => {
    var { error, disabled, readOnly, indeterminate, label, id, errorMessage, checked, margin, marginTop, marginBottom, marginRight, marginLeft, marginHorizontal, marginVertical, m, mt, mr, mb, ml, mx, my } = _a, props = __rest(_a, ["error", "disabled", "readOnly", "indeterminate", "label", "id", "errorMessage", "checked", "margin", "marginTop", "marginBottom", "marginRight", "marginLeft", "marginHorizontal", "marginVertical", "m", "mt", "mr", "mb", "ml", "mx", "my"]);
    return (React.createElement(Wrapper, Object.assign({ htmlFor: id }, {
        margin,
        marginTop,
        marginBottom,
        marginRight,
        marginLeft,
        marginHorizontal,
        marginVertical,
        m,
        mt,
        mr,
        mb,
        ml,
        mx,
        my,
    }),
        React.createElement(WrapperCheckbox, { disabled: disabled, readOnly: readOnly },
            React.createElement(Field, Object.assign({ error: error, id: id, type: "checkbox", readOnly: readOnly, checked: checked, indeterminate: indeterminate, disabled: disabled || readOnly, "aria-readonly": disabled || readOnly, "aria-checked": indeterminate ? 'mixed' : checked }, props)),
            React.createElement(CheckboxStyled, null,
                React.createElement(CheckboxIcon, { indeterminate: indeterminate })),
            label && React.createElement(ParagraphMd, { type: "default" }, label)),
        !disabled && error && errorMessage && (React.createElement(Caption, { type: "default" }, errorMessage))));
};

export { Checkbox as default };
